export * from './Intents';
export * from './Icon';
export * from './Heading';
export * from './Tag';
export * from './Colors';
export * from './PageContainer';
export * from './Section';
export * from './TabSection';
export * from './Button';
export * from './table/Table';
export * from './Card';
export * from './KeyValue';
export * from './EditableText';
export * from './InputGroup';
export * from './Checkbox';
export * from './Switch';
export * from './Select';
export * from './Dialog';
export * from './Popover';
export * from './Menu';
export * from './TagInput';
export * from './PageHeader';
export * from './PageLoader';
export * from './Alert';
export * from './Spinner';
export * from './Toaster';

export const majorScale = (n: number) => n * 8;
export const minorScale = (n: number) => n * 4;
